module.exports = __webpack_public_path__ + "static/media/nubelejos.2b1d4c23.svg";